var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinetuneParametersSpeakerDetection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 3.933a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8m0 6c1.98 0 4.067.974 4.067 1.4v.734H3.933v-.734c0-.426 2.087-1.4 4.067-1.4m0-7.266A2.666 2.666 0 1 0 8 8a2.666 2.666 0 1 0 0-5.333m0 6c-1.78 0-5.333.893-5.333 2.666v2h10.666v-2C13.333 9.56 9.78 8.667 8 8.667"
})));
export default SvgFinetuneParametersSpeakerDetection;